import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgOffice = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M21.9004 21.9004L20.5 23.2998L18.1504 21H2V4.7998L0.700195 3.5L2.09961 2.09961L21.9004 21.9004ZM12 7H22V19.1504L20 17.1504V9H11.8496L10 7.15039V5H7.84961L5.84961 3H12V7ZM4 19H6V17H4V19ZM8 19H10V17H8V19ZM12 19H16.1504L14.1504 17H12V19ZM4 15H6V13H4V15ZM8 15H10V13H8V15ZM18 13H16V11H18V13ZM4 11H6V9H4V11Z",
		fill: "#8D8D92"
	})
});
export default SvgOffice;
